var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 3.47,
    y: 12.04,
    width: 5.6,
    height: 18.91,
    rx: 0.82,
    transform: "matrix(0.99, 0.14, -0.14, 0.99, 3.03, -0.66)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.39,
    y: 12.04,
    width: 5.6,
    height: 18.91,
    rx: 0.82,
    transform: "translate(90.02 39.24) rotate(175.22)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.86,15.33l-4.66.22a2.27,2.27,0,0,1-1-.17l-6.89-2.75a2.82,2.82,0,0,0-1-.2H24.61a2,2,0,0,0-1.08.32l-4,2.63L17.09,20.1a2,2,0,0,0,.51,1.34,2.23,2.23,0,0,0,1.9.49,3.46,3.46,0,0,0,2.16-1.11l.51-.61.4-.49c.19-.24.48-.59.83-1.06.67-.18,1.26-.33,1.74-.44a2.56,2.56,0,0,1,1.21-.1,3.19,3.19,0,0,1,.89.48,10.85,10.85,0,0,1,1.06.8L31.43,22l2.76,2.24c.82.67,1.64,1.34,2.47,2l1.73,1.41a1.85,1.85,0,0,1,.28,2.59l-.45.57a1.84,1.84,0,0,1-2.55.34L30.12,27",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,13.73l-7.86,2.41-4.24-.62",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.89,
    y1: 27.56,
    x2: 38.71,
    y2: 27.86,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.82,30l5.68,4a2.13,2.13,0,0,0,2.88-.4h0a2.12,2.12,0,0,0-.38-3L32.86,29",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.49,26.8l-2.52,2a1.32,1.32,0,0,0-.14,1.92l.5.55a1.31,1.31,0,0,0,1.86.1l2.4-2.14a1.6,1.6,0,0,0,.1-2.3l0,0A1.6,1.6,0,0,0,14.49,26.8Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.05,28.06a1.51,1.51,0,0,0-2,0l-1,.85-2.29,2-.25.21a1.79,1.79,0,0,0-.13,2.58l.46.49a1.68,1.68,0,0,0,2.43.15l3-3.25.36-.38a1.51,1.51,0,0,0-.11-2.16l-.21-.19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.68,29.62,17.6,34.09a1.46,1.46,0,0,0,.17,2.12l.84.68a1.47,1.47,0,0,0,2-.21l3.36-4,.49-.6a1.5,1.5,0,0,0-.22-2.15l-.55-.44A1.51,1.51,0,0,0,21.68,29.62Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.06,32.07a1.71,1.71,0,0,1,1.77,1.53,1.4,1.4,0,0,1-.3.88l-.63.89L24.31,37.6a1.32,1.32,0,0,1-1.86.29l-.62-.48a1.3,1.3,0,0,1-.22-1.88l1.65-2,.84-1A1.53,1.53,0,0,1,25.06,32.07Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.79,34l1.62,1.24.67.52a2.34,2.34,0,0,0,1.88.5,2.15,2.15,0,0,0,.36-.11,1.78,1.78,0,0,0,1-.87A1.83,1.83,0,0,0,32.4,34",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,36.67a3.1,3.1,0,0,0,3.77.76,2.33,2.33,0,0,0,.85-1.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.08,
    y1: 28.75,
    x2: 8.16,
    y2: 28.23,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraw);
export default __webpack_public_path__ + "static/media/DRAW.7085a4b2503fd1d8f017037deaa9e31c.svg";
export { ForwardRef as ReactComponent };